/* @ngInject */
function formattedRoleFilter ($translate) {
  var _mRoles = {
    SYSTEM_ADMINISTRATOR: 'systemAdministrator',
    ADMINISTRATOR: 'administrator',
    DESIGNER: 'designer',
    USER: 'user',
    MANAGER: 'manager',
    CONSULTANT: 'consultant'
  }

  return function (sRole) {
    if (sRole && _mRoles[sRole]) {
      return $translate.instant(_mRoles[sRole])
    } else {
      return $translate.instant(_mRoles.USER)
    }
  }
}

export { formattedRoleFilter }
